import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "@/Axios/ConfiguredAxios";

// For Get API
export const useGet = ({
  apiURL,
  params = {},
  responseType = false,
  ...props
}) => {
  const axiosConfig = {};
  if (responseType) {
    axiosConfig.responseType = responseType;
  }

  const queryString = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

  const url = `${apiURL}${queryString ? `?${queryString}` : ""}`;

  const getQuery = useQuery({
    queryKey: [url, axiosConfig],
    queryFn: async () => {
      const response = await axiosInstance.get(url, axiosConfig);
      return response.data;
    },
    placeholderData: keepPreviousData,
    ...props,
  });

  return { ...getQuery };
};

const prepareHeaderConfig = (isFormData) => {
  const config = {};
  if (isFormData) {
    config.headers = { "Content-Type": "multipart/form-data" };
  } else {
    config.headers = { "Content-Type": "application/json" };
  }
  return config;
};

// For Post API
export const usePost = ({ apiURL, isFormData = false, ...props }) => {
  const mutation = useMutation({
    mutationFn: async (requestBody) => {
      const response = await axiosInstance.post(
        apiURL,
        requestBody,
        prepareHeaderConfig(isFormData)
      );
      return response.data;
    },
    ...props,
  });

  return { ...mutation };
};

// For Patch API
export const usePatch = ({ apiURL, isFormData = false, ...props }) => {
  const mutation = useMutation({
    mutationFn: async (requestBody) => {
      const response = await axiosInstance.patch(
        apiURL,
        requestBody,
        prepareHeaderConfig(isFormData)
      );
      return response.data;
    },
    ...props,
  });

  return { ...mutation };
};

// For Put API
export const usePut = ({ apiURL, isFormData = false, ...props }) => {
  const mutation = useMutation({
    mutationFn: async (requestBody) => {
      const response = await axiosInstance.put(
        apiURL,
        requestBody,
        prepareHeaderConfig(isFormData)
      );
      return response.data;
    },
    ...props,
  });

  return { ...mutation };
};

// For Delete API
export const useDelete = ({ apiURL, ...props }) => {
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await axiosInstance.delete(apiURL);
      return response.data;
    },
    ...props,
  });

  return { ...mutation };
};
